import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const systemMessageListRoute: RouteConfig = {
  path: '',
  name: 'systemMessageList',
  component: () => import(/* webpackChunkName: "SystemMessageList" */ '@/views/mainRoute/systemMessage/List.vue'),
  beforeEnter: (to, from, next) => {
    store
      .dispatch('systemMessage/list', { visibilityDate: new Date() })
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.SYSTEM_MESSAGE_CANNOT_LIST }));
  }
};
